import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { AllGradesOption } from 'teacher-ui-client/components/base/select/grade-position/options'

export default class ExcitingWritingIdeasController extends Controller {
  queryParams = ['pageNumber', 'perPage', 'grade', 'tags']

  @tracked pageNumber = 1

  @tracked perPage = 25

  @tracked private _grade = AllGradesOption.id

  @tracked private _tags: string = 'All'

  get grade() {
    return this._grade
  }

  set grade(value: number) {
    this._grade = value
    this.pageNumber = 1 // reset page number to 1 when grade changes
  }

  get tags() {
    return this._tags
  }

  set tags(value: string) {
    this._tags = value
    this.pageNumber = 1 // reset page number to 1 when tags change
  }
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/exciting-writing-ideas/index': ExcitingWritingIdeasController
  }
}
